import { PreloadModuleInfo } from '@meego-remote/core/app/contract';
import { PreloadDataInfo } from '../setup/HeavyCompsPrefetch/type';

/** 详情页组件预取扩展 */
export abstract class IComponentPreloadContribution {
  abstract key: string;

  abstract preload(
    params: {
      project_key: string;
      work_item_type_key: string;
      work_item_id: number;
      project_simple_name: string;
      [key: string]: any;
    },
    prefetchSpeculative?: boolean
  ): Promise<PreloadDataInfo>;

  abstract preloadResources(params: {
    project_key: string;
    work_item_type_key: string;
    work_item_id: number;
    project_simple_name: string;
    [key: string]: any;
  }): Promise<PreloadModuleInfo[]>;
}
